import http from "./../services/httpService";

// User Management (Admin only)
export async function getMCPUsers() {
    const resp = await http.get('/accounts/mcp/users/');
    return resp.data;
}

export async function createMCPUser(data) {
    const resp = await http.post('/accounts/mcp/users/', data);
    return resp.data;
}

export async function deleteMCPUser(id) {
    const resp = await http.delete(`/accounts/mcp/users/${id}/`);
    return resp.data;
}

export async function changeMCPUserPassword(id, password) {
    const resp = await http.post(`/accounts/mcp/users/${id}/password/`, { password });
    return resp.data;
}

// Token Management (Any authenticated user)
export async function getMCPTokens() {
    const resp = await http.get('/accounts/mcp/tokens/');
    return resp.data;
}

export async function createMCPToken(data) {
    const resp = await http.post('/accounts/mcp/tokens/', data);
    return resp.data;
}

export async function revokeMCPToken(id) {
    const resp = await http.delete(`/accounts/mcp/tokens/${id}/`);
    return resp.data;
}
